import { RuntimeEngine, SceneManager } from '@easytwin/runtime';
import { useBindSignal } from './useBindSignal';
import { useDumbState } from './useDumbState';

export const useMainScene = (engine: RuntimeEngine | undefined) => {
  const refresh = useDumbState();
  const sceneManager = engine?.getManager(SceneManager);
  useBindSignal(sceneManager?.signals.sceneUpdated, refresh);
  return sceneManager?.mainScene;
};
